export const BACKEND_BASE =
  process.env.REACT_APP_BACKEND_BASE ||
  "https://game-database-backend.onrender.com";
